const parseColorToRgba = (color) => {
  if (!color) return null;
  if (color[0] === "#") {
    let hex = color.slice(1);
    if (hex.length === 3 || hex.length === 4) {
      hex = hex.split("").map((c) => c + c).join("");
    }
    if (hex.length === 6 || hex.length === 8) {
      const bigint = parseInt(hex, 16);
      const hasAlpha = hex.length === 8;
      return {
        r: bigint >> (hasAlpha ? 24 : 16) & 255,
        g: bigint >> (hasAlpha ? 16 : 8) & 255,
        b: bigint >> (hasAlpha ? 8 : 0) & 255,
        a: hasAlpha ? (bigint & 255) / 255 : 1
      };
    }
    return null;
  }
  const match = color.replace(/\s+/g, "").match(/^rgba?\((\d+),(\d+),(\d+)(?:,([\d.]+))?\)$/i);
  if (match) {
    return {
      r: Number(match[1]),
      g: Number(match[2]),
      b: Number(match[3]),
      a: match[4] !== void 0 ? Number(match[4]) : 1
    };
  }
  return null;
};
const compositeColors = (bg, fg) => {
  const a = fg.a + bg.a * (1 - fg.a);
  if (a === 0) {
    return { r: 0, g: 0, b: 0, a: 0 };
  }
  return {
    r: Math.round((fg.r * fg.a + bg.r * bg.a * (1 - fg.a)) / a),
    g: Math.round((fg.g * fg.a + bg.g * bg.a * (1 - fg.a)) / a),
    b: Math.round((fg.b * fg.a + bg.b * bg.a * (1 - fg.a)) / a),
    a
  };
};
const rgbaToRgbString = (rgba) => `rgb(${rgba.r}, ${rgba.g}, ${rgba.b})`;
export {
  compositeColors,
  parseColorToRgba,
  rgbaToRgbString
};
//# sourceMappingURL=colorUtils.js.map
